import React, { useState, useEffect, useRef } from "react";
import "flatpickr/dist/themes/material_green.css";

import Flatpickr from "react-flatpickr";
import {
  Card,
  CardBody,
  Col,
  Row,
  CardTitle,
  Form,
  Container,
  Label,
  Input,
  Button,
} from "reactstrap";
import URLSearchParams from "@ungap/url-search-params";
// React Select
import Select from "react-select";
// MomentJS
import moment from "moment";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";

const UpdateCode = (props) => {
  const [campaignInfo, setCampaignInfo] = useState({
    bundle: "",
    created_at: "",
    discount_amount: "",
    discount_categories: "",
    discount_merchants: "",
    discount_products: "",
    discount_store_wide: "",
    discount_type: "",
    end_date: "",
    id: "",
    marketplace_id: "",
    max_discount: "",
    max_limit_per_day: "",
    max_limit_per_user: "",
    max_promocodes_allocated: "",
    min_quantity: "",
    min_spend: "",
    name: "",
    payment_method: "",
    promocodes: [],
    start_date: "",
    tnc: "",
    updated_at: "",
    user_id: null,
  });
  const [max_limit_per_day, setMaxLimitPerDay] = useState(false);
  const [max_limit_per_user, setMaxLimitPerUser] = useState(false);
  const [noOfCodesCheck, setNoofCodesCheck] = useState(false);
  const [noOfCodes, setnoOfCodes] = useState(null);
  const [noOfCodesError, setNoOfCodesError] = useState(null);
  const [success_msg, setsuccess_msg] = useState(false);
  const [noOfCodesValue, setNoofCodesValue] = useState("");
  const [errorMessage, SetErrorMessage] = useState("");
  const [errorMsgAlert, setErrorMsgAlert] = useState(false);
  const [bundlecheck, setBundlecheck] = useState();
  const [isMerchantLoggedIn, setIsMerchant] = useState(false);
  const [product, setProduct] = useState([]);
  const fps = useRef(null);
  const fpe = useRef(null);

  useEffect(() => {
    let token = "";
    const isMerchant = localStorage?.getItem("isMerchant");
    if (isMerchant == "true") {
      setIsMerchant(true);
      token = localStorage.getItem("merchantToken");
    } else {
      setIsMerchant(false);
      token = localStorage.getItem("merchantToken");
    }
    if(localStorage.getItem("userRole")?.includes("merchant")){
      token=localStorage.getItem("AuthenticationToken")
      console.log("here is the token---->",token)
    }
    const campaign_id = props.history?.location.state.cat_ID;
    if (token) {
      getCampaign(campaign_id, token);
    }
    return () => {};
  }, [props]);

  const getCampaign = async (campaignID, token) => {
    let _headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + token,
    };
    var requestOptions = {
      method: "GET",
      headers: _headers,
      redirect: "follow",
    };
    let url =
      `${process.env.REACT_APP_TOKRI_API_URL}/api/campaigns/` + campaignID;
    await fetch(url, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let result1 = JSON.parse(result);
        let campaignData = result1[0];
        console.log("typeoffff", campaignData);
        setProduct(JSON.parse(campaignData?.discount_products));

        // console.log('====total===>', JSON.parse(campaignData.discount_products.length))
        if (campaignData?.bundle == 1 || campaignData?.bundle == "1") {
          setBundlecheck(true);
        }
        setCampaignInfo(campaignData);
        console.log("Set value no of elems", campaignData);
        fps.current.flatpickr.setDate(new Date(moment(campaignData.start_date)));
        fpe.current.flatpickr.setDate(new Date(moment(campaignData.end_date)));
        // $("#end_date_input").val(campaignData.end_date);
        // document.getElementById("end_date_input").value = moment(
        //   campaignData.end_date
        // ).format("YYYY/MM/DD HH:mm");
        // document.getElementById("start_date_input").value = moment(
        //   campaignData.start_date
        // ).format("YYYY/MM/DD HH:mm");

        if (campaignInfo?.max_limit_per_day == -1) {
          setMaxLimitPerDay(true);
        }
        if (campaignInfo?.max_limit_per_user == -1) {
          setMaxLimitPerUser(true);
        }
      })
      .catch((error) => console.log("error", error));
  };
  const getCurrentDate = (prevDate) => {
    let date = "";
    if (prevDate) {
      date = moment(prevDate).format("YYYY-MM-DD ,hh:mm A");
      // .format("YYYY-MM-DDTHH:mm")
    } else {
      date = moment(new Date()).format("YYYY-MM-DD ,hh:mm A");
    }

    return date;
  };

  function handleNoCodesInput(e) {
    var regex1 = /[A-Z]|[a-z]/g;
    var regex = /[-+]?([0-9]*\.[0-9]+|[0-9]+)/g;
    var str = e.target.value.toString();
    setNoofCodesValue(e.target.value);
    if (e.target.value == "") {
      setnoOfCodes(false);
      setNoOfCodesError(false);
    } else if (regex.test(str) && !regex1.test(str)) {
      setnoOfCodes(true);
      setNoOfCodesError(false);
    } else if (!regex.test(str)) {
      setnoOfCodes(null);
      setNoOfCodesError(true);
    }
  }
  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={() => {
          props?.history.push("/merchant-dashboard");
        }}
        onConfirm={() => {
          setsuccess_msg(false);
          props?.history.push("/merchant-dashboard");
        }}
        onCancel={() => {
          setsuccess_msg(false);
        }}
      >
        {"Campaign Updated Successfully."}
      </SweetAlert>
    );
  };
  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorMsgAlert(false);
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };

  function handleSubmit(e) {
    e.preventDefault();
    console.log('fpe', fpe.current.flatpickr.selectedDates[0]);
    var end_date = moment(fpe.current.flatpickr.selectedDates[0]).format("YYYY-MM-DDTHH:mm");
    //var end_date = document.getElementById("end_date_input").value;
    console.log('end_date', end_date);
    var tnc = document.getElementById("terms-and-conditions-input").value;
    // if(!noOfCodesCheck)
    // {
    //   if (quantityofCodes === "") {
    //   setnoOfCodes(false)
    //   }
    //   else {
    //   setnoOfCodes(true)
    //   }
    // }

    var d1 = document.getElementsByName("validate");

    document.getElementById("tooltipForm").classList.add("was-validated");

    for (var i = 0; i < d1.length; i++) {
      d1[i].style.display = "block";
    }
    // post form data to api
    if (end_date !== "" || tnc !== "") {
      updateCampaign(end_date, tnc);
    }
  }

  const updateCampaign = (end_date, tnc) => {
    let token=''
    if(localStorage.getItem("userRole")?.includes("merchant")){
      token=localStorage.getItem("AuthenticationToken")
    }else{
    token = localStorage.getItem("merchantToken");
    }
    const campaign_id = props.history?.location.state.cat_ID;
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", "Bearer " + token);

    var urlencoded = new URLSearchParams();
    // urlencoded.append("marketplace_id", "6a125896-1fe8-4fb0-9e13-8f45f1131d44"); // uncomment this for localhost
    urlencoded.append(
      "marketplace_id",
      window.location.hostname == "tokri.spoonspace.com"
        ? "6a125896-1fe8-4fb0-9e13-8f45f1131d44"
        : "53fc4dac-490c-4dca-a255-dfc9c4310890"
    ); // comment this for localhost
    console.log("ops", tnc);
    urlencoded.append("id", campaign_id);
    urlencoded.append("end_date", end_date);

    urlencoded.append("tnc", tnc);

    // if (promoLimitCheck) {
    //   urlencoded.append("max_promocodes_allocated", -1);
    // } else {
    //   urlencoded.append("max_promocodes_allocated", noOfCodes);
    // }
    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/campaigns/update`,
      requestOptions
    )
      .then((response) => response.json())

      .then((result) => {
        if (result.message.toLowerCase() === "campaign updated successfully") {
          setsuccess_msg(true);
        } else {
          SetErrorMessage(result.message);
          setErrorMsgAlert(true);
        }
      })
      .catch((error) => console.log("Campaign Updation error", error));
  };

  const handleNoofCodesCheck = () => {
    setNoofCodesCheck(!noOfCodesCheck);
  };

  console.log("compein product", campaignInfo);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row style={{ marginBottom: 10, justifyContent: "space-between" }}>
            {isMerchantLoggedIn && <Col lg={1}></Col>}
            <Col lg={2} md={6} sm={6}>
              <CardTitle style={{}} className="h4">
                Update Campaign
              </CardTitle>
            </Col>
            <Col lg={4}></Col>
            <Col lg={5} md={12} sm={12}>
              <Row lg={6} md={6} sm={2}>
                <Col lg={2} style={{ marginTop: 5, textAlign: "center" }}>
                  Status:
                </Col>
                <div
                  lg={2}
                  style={{
                    backgroundColor: "black",
                    color: "white",
                    textAlign: "center",
                    padding: 5,
                  }}
                >
                  {/* {campaignInfo.status} */}
                  {campaignInfo.status == "active" ? "Active" : "Paused"}
                </div>
                <div lg={2}>
                  {/* <i className="uil-file-download-alt" style={{fontSize: 24, alignSelf: "right", color: "black"}} /> */}
                </div>
              </Row>
            </Col>
            {/* <Col lg={2}>
                            
                           
                        <CSVLink style={{flexDirection: "column",   flex: 1}} {...csvReport}>
                        <Row lg={2} style={{textAlign: ""}}>
                              <i className="uil-file-download-alt" style={{fontSize: 24, alignSelf: "right", color: "black"}} />
                               <p style={{fontSize: 16, color: "black" , alignSelf: "left"}}>CSV</p>
                        
                         
                        
                         </Row>
                         </CSVLink> 
                        
                        </Col> */}
          </Row>
          <Row>
            {isMerchantLoggedIn && <Col lg={1}></Col>}
            <Col lg={10} md={10} sm={10}>
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={10} md={10} sm={10}>
                      <div className="mt-5 mt-lg-4">
                        <Form className="" method="post" id="tooltipForm">
                          <div>
                            <Row>
                              <Col lg={5} md={6} sm={6}>
                                <div className="mb-4 position-relative">
                                  <Label
                                    className="col-sm-8 col-form-label"
                                    htmlFor="formrow-firstname-input"
                                  >
                                    Campaign Name
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="promocode-input"
                                    disabled={true}
                                    value={campaignInfo?.name}
                                    required
                                  />
                                </div>
                              </Col>
                            </Row>

                            <Row lg={12} md={12} sm={12}>
                              <Col lg={4} md={6} sm={6}>
                                <div className="mb-3">
                                  <Label>Discount Type</Label>
                                  <Select
                                    value={campaignInfo?.discount_type}
                                    isDisabled={true}
                                    placeholder={
                                      campaignInfo?.discount_type === "amount"
                                        ? "Fixed Amount"
                                        : "Percentage Discount"
                                    }
                                    required
                                  />
                                </div>
                              </Col>
                              <Col lg={2} md={6} sm={6}>
                                <div
                                  className="form-check mb-12"
                                  style={{ marginTop: 40, marginLeft: 10 }}
                                >
                                  {console.log("bundle", campaignInfo)}
                                  <input
                                    className="form-check-input-lg"
                                    type="checkbox"
                                    defaultChecked={bundlecheck}
                                    id="bundle-check"
                                    disabled={true}
                                  />
                                  <label
                                    className="form-check-label-lg"
                                    htmlFor="invalidCheck"
                                    style={{ marginLeft: 5, fontSize: 14 }}
                                  >
                                    Bundle
                                  </label>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={5} md={6} sm={6}>
                                <div className="mb-3 position-relative">
                                  <Label
                                    className="form-label"
                                    htmlFor="formrow-firstname-input"
                                  >
                                    Amount(
                                    {campaignInfo?.discountType == "amount"
                                      ? "$"
                                      : "%"}
                                    )
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="amount-input"
                                    disabled={true}
                                    value={campaignInfo?.discount_amount}
                                    required
                                  />
                                </div>
                              </Col>
                              <Col lg={1}></Col>
                              {/* <Col lg={5} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Payment Method</Label>
                              <Select
                                value={campaignInfo?.payment_method}
                                placeholder={campaignInfo?.payment_method}
                                isDisabled={true}
                                required
                              />
                            </div>
                            </Col> */}
                            </Row>
                            <Row>
                              <Col lg={5} md={6} sm={6}>
                                <div className="mb-3 position-relative">
                                  <Label
                                    className="form-label"
                                    htmlFor="formrow-firstname-input"
                                  >
                                    Start Date
                                  </Label>
                                  <div className="col-md-12">
                                    <Flatpickr
                                      data-enable-time
                                      className="form-control"
                                      type="datetime-local"
                                      id="start_date_input"
                                      disabled
                                      options={{
                                        dateFormat: "d/m/Y h:i K",
                                      }}
                                      ref={fps}
                                    />
                                  </div>
                                </div>
                              </Col>
                              <Col lg={1}></Col>
                              <Col lg={5} md={6} sm={6}>
                                <div className="mb-3 position-relative">
                                  <Label>End Date</Label>
                                  <div className="col-md-12">
                                    <Flatpickr
                                      style={{ background: "white" }}
                                      // value={moment(
                                      //   campaignInfo?.end_date
                                      // ).format("YYYY-MM-DDTHH:mm")}
                                      data-enable-time
                                      className="form-control"
                                      type="datetime-local"
                                      id="end_date_input"
                                      options={{
                                        dateFormat: "d/m/Y h:i K",
                                      }}
                                      ref={fpe}
                                    />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            {/* <Row lg={12} md={12} sm={12}>
                            {console.log("Checking Campaign Info", campaignInfo)}
                            <Col lg={4} md={6} sm={6}>
                            <div className="mb-3 position-relative">
                              <Label>No. of Promo Codes</Label>
                              <Input type="text" className="form-control" id="no-of-codes-input"
                              disabled={true}
                              value={campaignInfo ? campaignInfo?.max_promocodes_allocated == -1 ? "" : campaignInfo?.max_promocodes_allocated : noOfCodesValue}
                              onChange={(e)=>{
                                  handleNoCodesInput(e)
                              }}
                              required/>
                              {!noOfCodesCheck && noOfCodes == true &&
                              <div style={{fontSize: 12, color: "green"}}>
                                Looks good!
                              </div>}
                              {!noOfCodesCheck && noOfCodes == false && 
                              <div style={{color: "red", fontSize: 12, fontWeight: "300"}}>
                                Please enter no of codes.
                              </div>}
                              {!noOfCodesCheck && noOfCodesError == true &&
                              <div style={{color: "red", fontSize: 12, fontWeight: "300"}}>
                                No. of codes is not valid.
                              </div>}
                            </div>
                            </Col>
                            <Col lg={2} md={6} sm={4}>
                            <div className="form-check mb-8" style={{marginTop: 40, marginLeft: 10}}>
                            <input className="form-check-input-lg" type="checkbox" defaultChecked={campaignInfo?.max_promocodes_allocated == -1 ? true : false} id="no-of-promocode-check" disabled={true}
                            onChange={()=>{handleNoofCodesCheck()}}
                              required />
                            <label className="form-check-label-lg" htmlFor="invalidCheck" style={{marginLeft: 5, fontSize: 14}}>
                            No Limit?
                            </label>
                          </div>
                            </Col>
                          </Row> */}
                            {/* <Row lg={12} md={12} sm={12}>
                            <Col lg={4} md={6} sm={6}>
                            <div className="mb-3 position-relative">
                              <Label>Max per user/per day</Label>
                              <Select
                                value={campaignInfo?.max_limit_per_day}
                                placeholder={campaignInfo?.max_limit_per_day == -1 ? "--" : campaignInfo?.max_limit_per_day} 
                                isDisabled={true}
                                required
                              />
                            </div>
                            </Col>
                            <Col lg={2} md={4} sm={4}>
                            <div className="form-check mb-3" style={{marginTop: 40, marginLeft: 10}}>
                            <input className="form-check-input-lg" type="checkbox" checked={max_limit_per_day} id="max-user-per-day-check"
                              disabled={true}
                              required />
                            <label className="form-check-label-lg" htmlFor="invalidCheck" style={{marginLeft: 5, fontSize: 14}}>
                            No Limit?
                            </label>
                          </div>
                            </Col>
                            <Col lg={1}></Col>
                            <Col lg={3} md={6} sm={6}>
                            <div className="mb-6">
                              <Label>Max per user/per Campaign</Label>
                              <Select
                                value={campaignInfo?.max_limit_per_user}
                                placeholder={campaignInfo?.max_limit_per_user == -1 ? "--" : campaignInfo?.max_limit_per_user}
                                isDisabled={true}
                              />
                            </div>
                            </Col>
                            <Col lg={2} md={4} sm={4}>
                            <div className="form-check mb-3" style={{marginTop: 40, marginLeft: 10}}>
                            <input className="form-check-input-lg" type="checkbox" checked={max_limit_per_user} 
                            id="max-user-per-campaign-check"
                            disabled={true}
                              required />
                            <label className="form-check-label-lg" htmlFor="invalidCheck" value="checked" style={{marginLeft: 5, fontSize: 14}}>
                            No Limit?
                            </label>
                          </div>
                            </Col>
                          </Row> */}
                            <Row>
                              <Col lg={5} md={6} sm={6}>
                                <div className="mb-3 position-relative">
                                  <Label
                                    className="form-label"
                                    htmlFor="formrow-firstname-input"
                                  >
                                    Minimum Spend($)
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="minspend-input"
                                    value={campaignInfo?.min_spend}
                                    disabled={true}
                                    required
                                  />
                                </div>
                              </Col>
                              <Col lg={1}></Col>
                              <Col lg={5} md={6} sm={6}>
                                {campaignInfo?.discount_type == "percent" && (
                                  <div className="mb-3 position-relative">
                                    <Label
                                      className="form-label"
                                      htmlFor="formrow-firstname-input"
                                    >
                                      Maximum Discount($)
                                    </Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="max-discount-input"
                                      value={campaignInfo?.max_discount}
                                      disabled={true}
                                      required
                                    />
                                  </div>
                                )}
                              </Col>
                            </Row>
                            {/* <Row>
                            <Col lg={6} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Merchant</Label>
                              <Row lg={12} md={12} sm={12}>
                              <Col lg={12} md={12} sm={12}>
                              <Select
                                placeholder={campaignInfo?.discount_merchants ? JSON.parse(campaignInfo.discount_merchants) : ""}
                                value={campaignInfo?.discount_merchants ? JSON.parse(campaignInfo.discount_merchants) : ""}
                                isDisabled={true}                                
                                isMulti
                              />
                              </Col>
                              </Row>
                            </div>
                            </Col>
                          </Row> */}
                            {/* <Row>
                            <Col lg={6} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Category</Label>
                              <Select
                                placeholder={campaignInfo?.discount_categories ? JSON.parse(campaignInfo.discount_categories) : ""}
                                value={campaignInfo?.discount_categories ? JSON.parse(campaignInfo.discount_categories) : ""}
                                isDisabled={true}
                                isMulti
                              />
                            </div>
                            </Col>
                          </Row> */}
                            <Row>
                              <Col lg={5} md={6} sm={6}>
                                <div className="mb-4 position-relative">
                                  <Label
                                    className="col-sm-8 col-form-label"
                                    htmlFor="formrow-firstname-input"
                                  >
                                    {"Terms & Conditions"}
                                  </Label>
                                  <Input
                                    type="textarea"
                                    className="form-control"
                                    id="terms-and-conditions-input"
                                    defaultValue={
                                      campaignInfo?.tnc !== null
                                        ? campaignInfo?.tnc
                                        : "NA"
                                    }
                                    // disabled={true}
                                  />
                                </div>
                              </Col>
                            </Row>

                            {campaignInfo.discount_store_wide == 1 ? (
                              <Row>
                                <Col lg={5} md={6} sm={6}>
                                  <div className="mb-3">
                                    <Label>Product</Label>
                                    <Select isDisabled={true} />
                                  </div>
                                </Col>

                                <Col lg={1}></Col>
                                <Col lg={3} md={6} sm={6}>
                                  <div className="mb-3 position-relative">
                                    <Label>Minimum Quantity</Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="minquantity-input"
                                      disabled={true}
                                      required
                                    />
                                  </div>
                                </Col>
                                <Col lg={3} style={{ alignContent: "center" }}>
                                  <div
                                    className="form-check mb-3"
                                    style={{ marginTop: 40, marginLeft: 10 }}
                                  >
                                    <input
                                      className="form-check-input-lg"
                                      style={{ display: "inline-block" }}
                                      type="checkbox"
                                      defaultChecked={true}
                                      id="bundle-check"
                                      disabled={true}
                                    />
                                    <label
                                      className="form-check-input-lg"
                                      htmlFor="invalidCheck"
                                      style={{
                                        marginLeft: 5,
                                        fontSize: 14,
                                        display: "inline-block",
                                      }}
                                    >
                                      Select Entire Store
                                    </label>
                                  </div>
                                </Col>
                              </Row>
                            ) : (
                              product.map((item, index) => (
                                <Row>
                                  {console.log("index", index, item)}
                                  <Col lg={6} md={6} sm={6}>
                                    <div className="mb-3">
                                      {index === 0 && <Label>Product</Label>}
                                      <Select
                                        placeholder={item ? item.label : ""}
                                        value={item ? item.label : ""}
                                        isDisabled={true}
                                      />
                                    </div>
                                  </Col>

                                  <Col lg={1}></Col>
                                  <Col lg={5} md={6} sm={6}>
                                    <div className="mb-3 position-relative">
                                      {index === 0 && (
                                        <Label>Minimum Quantity</Label>
                                      )}
                                      <Input
                                        type="text"
                                        className="form-control"
                                        id="minquantity-input"
                                        value={item?.min_qty}
                                        disabled={true}
                                        required
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              ))
                            )}
                            {success_msg ? renderSuccessAlert() : null}
                            {errorMsgAlert ? renderFailureAlert() : null}

                            <div className="text-left mt-4">
                              <Button
                                type="submit"
                                color="primary"
                                className="btn btn-primary waves-effect waves-light"
                                onClick={(e) => {
                                  handleSubmit(e);
                                }}
                              >
                                Update Campaign
                              </Button>

                              <Link
                                style={{ marginLeft: "10px" }}
                                to="/merchant-dashboard"
                              >
                                <Button outline color="secondary" size="md">
                                  Cancel
                                </Button>
                              </Link>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UpdateCode;
